export enum UserRoleName {
  Admin = "admin",
  Manager = "manager",
  PowerUse = "power use",
  Sales = "sales",
  VR = "VR",
}
